import Interweave from 'interweave'
import { isEmpty } from 'lodash-es'
import PropTypes from 'prop-types'
import { convertMdToHtml } from '..'
import Section from '../../Section'

export const buildRepoScopeContent = repoFiles =>
  repoFiles
    .map(repo => {
      const paths = []
      if (repo.includePaths?.length && repo.hideIncluded !== true) {
        paths.push(
          `<p>Included Paths: ${repo.includePaths
            .map(path => `<code>${path}</code>`)
            .join(', ')}</p>`,
        )
      }
      if (repo.excludePaths?.length && repo.showExcluded) {
        paths.push(
          `<p>Excluded Paths: ${repo.excludePaths
            .map(path => `<code>${path}</code>`)
            .join(', ')}</p>`,
        )
      }
      if (repo.extensions?.length) {
        paths.push(
          `<p>Extensions: ${repo.extensions.map(ext => `<code>${ext}</code>`).join(', ')}</p>`,
        )
      }

      // The repo line only heads the paths below it, so a repo left with none of
      // them - `Hide included` on a repo whose exclusions are hidden too and
      // which sets no extensions - is dropped rather than printed as a bare
      // `Repo:` line with nothing under it.
      if (!paths.length) {
        return undefined
      }

      return `<p>Repo: <code>${repo.name}</code></p>${paths.join('')}`
    })
    .filter(Boolean)
    .join('<br>')

const Scope = ({ report: { reportContent } }) => {
  const includeContent = buildRepoScopeContent(reportContent.repoFiles)

  return (
    <Section title="Scope">
      {!isEmpty(reportContent.summary.scope?.description) ? (
        <Interweave content={convertMdToHtml.makeHtml(reportContent.summary.scope?.description)} />
      ) : null}
      {!isEmpty(reportContent.summary.scope?.filesIncluded) || !isEmpty(includeContent) ? (
        <div>
          <h4>Files Included</h4>
          <Interweave
            content={convertMdToHtml.makeHtml(reportContent.summary.scope?.filesIncluded)}
          />
          {includeContent?.length ? (
            <div className="scope-files-list">
              <Interweave content={convertMdToHtml.makeHtml(includeContent)} />
            </div>
          ) : null}
        </div>
      ) : null}
      {!isEmpty(reportContent.summary.scope?.filesExcluded) ? (
        <div>
          <h4>Files Excluded</h4>

          <Interweave
            content={convertMdToHtml.makeHtml(reportContent.summary.scope?.filesExcluded)}
          />
        </div>
      ) : null}
    </Section>
  )
}

Scope.propTypes = {
  report: PropTypes.object,
}

export default Scope
